import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalDateFormatService } from '../services/local-date-format.service';

@Pipe({
  name: 'localDateFormat',
  pure: false,
})
export class LocalDateFormatPipe implements PipeTransform {
  private localDateFormatService = inject(LocalDateFormatService);

  transform(value: string | undefined, showTime?: boolean): string {
    return this.localDateFormatService.transform(value, showTime);
  }
}
